export enum AdminAuthRoutes {
  BasePrefix = "auth",
  Login = "login",
  ActiveDirectoryLogin = "ad-login",
  RefreshToken = "token/refresh"
}
